<div class="container">
    <div *ngIf="!showShimmer && word">
        <h3>{{word.base}}</h3>
        <!-- <h3>Think Of</h3>
        <div class="form-item">
            <h4 class="title usmall">think of/about someone/something</h4>
            <div class="mt-3">
                <div class="meaning-item"><span>to remember or imagine someone or something:</span></div>
                <p class="example">I thought of you immediately when they said they wanted someone who could speak
                    English.</p>
            </div>
        </div> -->
        <div class="form-item" *ngFor="let form of word.forms">
            <h4 class="title usmall">{{form.text}}</h4>
            <div class="mt-3" *ngFor="let meaning of form.meanings">
                <div class="meaning-item"><span>{{meaning.text}}</span></div>
                <p class="example">{{meaning.example}}</p>
            </div>
        </div>
    </div>

    <div class="shimmer-container" *ngIf="showShimmer">
        <h3 class="shimmerBG title-line"></h3>
        <div class="form-item">
            <h4 class="title usmall shimmerBG title-line2"></h4>
            <div class="mt-3">
                <div class="meaning-item shimmerBG title-line2"><span class=""></span></div>
                <div class="example shimmerBG content-line"></div>
            </div>
        </div>
        
    </div>
</div>